"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountTransactions = void 0;
var bignumber_js_1 = require("bignumber.js");
var env_1 = require("../../../env");
var network_1 = __importDefault(require("../../../network"));
var LIMIT = 100; // Max nb of transactions per request
var BASE_URL = (0, env_1.getEnv)("API_ALGORAND_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
var INDEXER_URL = "".concat(BASE_URL, "/idx2/v2");
var fullUrl = function (route) {
    return "".concat(INDEXER_URL).concat(route, "?limit=").concat(LIMIT);
};
var getAccountTransactions = function (address, startAt) { return __awaiter(void 0, void 0, void 0, function () {
    var url, nextToken, newRawTxs, mergedTxs, nextUrl, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = fullUrl("/accounts/".concat(address, "/transactions"));
                newRawTxs = [];
                mergedTxs = [];
                _a.label = 1;
            case 1:
                nextUrl = url;
                if (startAt) {
                    nextUrl = nextUrl.concat("&min-round=".concat(startAt));
                }
                if (nextToken) {
                    nextUrl = nextUrl.concat("&next=".concat(nextToken));
                }
                return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: nextUrl
                    })];
            case 2:
                data = (_a.sent()).data;
                nextToken = data["next-token"];
                newRawTxs = data.transactions;
                newRawTxs.map(parseRawTransaction).forEach(function (tx) { return mergedTxs.push(tx); });
                _a.label = 3;
            case 3:
                if (newRawTxs.length >= LIMIT) return [3 /*break*/, 1];
                _a.label = 4;
            case 4: return [2 /*return*/, mergedTxs];
        }
    });
}); };
exports.getAccountTransactions = getAccountTransactions;
var parseRawTransaction = function (tx) {
    var details = undefined;
    if (tx["tx-type"] === "pay") {
        var info = tx["payment-transaction"];
        var paymentInfo = {
            amount: new bignumber_js_1.BigNumber(info.amount),
            recipientAddress: info.receiver,
            closeAmount: info["close-amount"] === undefined
                ? undefined
                : new bignumber_js_1.BigNumber(info["close-amount"]),
            closeToAddress: info["close-remainder-to"]
        };
        details = paymentInfo;
    }
    else if (tx["tx-type"] === "axfer") {
        var info = tx["asset-transfer-transaction"];
        var assetTransferInfo = {
            assetAmount: new bignumber_js_1.BigNumber(info.amount),
            assetId: info["asset-id"],
            assetRecipientAddress: info.receiver,
            assetSenderAddress: info.sender,
            assetCloseAmount: info["close-amount"] === undefined
                ? undefined
                : new bignumber_js_1.BigNumber(info["close-amount"]),
            assetCloseToAddress: tx["close-to"]
        };
        details = assetTransferInfo;
    }
    return {
        id: tx.id,
        timestamp: tx["round-time"],
        round: tx["confirmed-round"],
        senderAddress: tx.sender,
        senderRewards: new bignumber_js_1.BigNumber(tx["sender-rewards"]),
        recipientRewards: new bignumber_js_1.BigNumber(tx["receiver-rewards"]),
        closeRewards: tx["close-rewards"] === undefined
            ? undefined
            : new bignumber_js_1.BigNumber(tx["close-rewards"]),
        closeAmount: tx["closing-amount"] === undefined
            ? undefined
            : new bignumber_js_1.BigNumber(tx["closing-amount"]),
        fee: new bignumber_js_1.BigNumber(tx.fee),
        note: tx.note,
        type: tx["tx-type"],
        details: details
    };
};
//# sourceMappingURL=indexer.js.map